import { useEffect, useState } from "react";
import { TowersSportsApi } from "../apis/towers-sports-api/towers-sports-api";
import { AcestreamConnectionsResponse, ActiveViewer } from "../apis/towers-sports-api/types";

export const useAcestreamActiveConnections = () => {
    const [activeConnections, setActiveConnections] = useState<AcestreamConnectionsResponse>({connections: {}});

    useEffect(() => {
        const fetchActiveConnections = async () => {
            try {
                const data = await TowersSportsApi.getAcestreamActiveConnections();
                setActiveConnections(data);
            } catch (error) {
                console.error("Error fetching active connections:", error);
            }
        };

        fetchActiveConnections();

        const intervalId = setInterval(fetchActiveConnections, 5000); // Actualizar cada 5 segundos

        return () => clearInterval(intervalId); // Limpiar el intervalo al desmontar el componente
    }, []);

    const getViewers: (hash: string) => ActiveViewer[] = (hash) => {
        return activeConnections.connections[hash] || [];
    };

    return {activeConnections, getViewers};
}